import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Bus, Home, Users, CalendarCheck, MapPin, Bell, LogOut } from "lucide-react";
import { Toaster } from "sonner";

const tabs = [
  { to: "/parent", icon: Home, label: "Accueil", end: true, id: "parent-tab-home" },
  { to: "/parent/children", icon: Users, label: "Enfants", id: "parent-tab-children" },
  { to: "/parent/reservations", icon: CalendarCheck, label: "Résa", id: "parent-tab-reservations" },
  { to: "/parent/tracking", icon: MapPin, label: "Suivi", id: "parent-tab-tracking" },
  { to: "/parent/notifications", icon: Bell, label: "Alertes", id: "parent-tab-notifications" },
];

export default function ParentLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Toaster position="top-center" richColors closeButton />

      <header className="sticky top-0 z-40 bg-white border-b border-zinc-900">
        <div className="px-4 py-3 flex items-center justify-between max-w-xl mx-auto">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#FFC60A] border border-zinc-900 flex items-center justify-center">
              <Bus size={16} />
            </div>
            <div>
              <div className="font-display font-black text-base tracking-tighter">LOGIBUS</div>
              <div className="text-[9px] font-mono tracking-[0.25em] uppercase text-zinc-500">Parent</div>
            </div>
          </div>
          <div className="text-right">
            <div className="text-xs font-semibold">{user?.name}</div>
            <div className="text-[9px] font-mono tracking-[0.2em] uppercase text-zinc-500" data-testid="parent-tenant-name">{user?.tenant?.name}</div>
            <button data-testid="parent-logout-button" onClick={async () => { await logout(); navigate("/login"); }}
              className="text-[10px] font-mono tracking-widest uppercase text-zinc-500 hover:text-zinc-900 inline-flex items-center gap-1">
              <LogOut size={11} /> Sortir
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 pb-20 max-w-xl w-full mx-auto">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-zinc-900 grid grid-cols-5 max-w-xl mx-auto" data-testid="parent-bottom-nav">
        {tabs.map(({ to, icon: Icon, label, end, id }) => (
          <NavLink key={to} to={to} end={end} data-testid={id} className={({ isActive }) =>
            `py-2.5 flex flex-col items-center gap-1 text-[10px] font-bold tracking-widest uppercase border-r border-zinc-900 last:border-r-0 ${isActive ? "bg-[#FFC60A]" : "bg-white"}`}>
            <Icon size={16} /> {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
